import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export const Footer: React.FC = () => {
  const [open, setOpen] = useState(false);
  return <>
      <footer className="w-full bg-white border-t border-gray-100 py-6 px-6" data-id="element-7">
        <div className="max-w-2xl mx-auto flex flex-col items-center gap-2 text-center" data-id="element-8">
          <p className="text-xs text-gray-400" data-id="element-9">
            © {new Date().getFullYear()} Protocolo Mente Serena. Todos los
            derechos reservados.
          </p>
          <button onClick={() => setOpen(true)} className="text-xs text-gray-500 hover:text-dark-blue underline underline-offset-2 transition-colors" data-id="element-10">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-11">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)} data-id="element-12">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-13">
              {/* Modal Header */}
              <div className="flex items-center justify-between px-8 py-6 border-b border-gray-100 shrink-0" data-id="element-14">
                <h2 className="text-2xl font-bold text-dark-blue" data-id="element-15">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setOpen(false)} className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors" aria-label="Cerrar" data-id="element-16">
                  <XIcon className="w-5 h-5 text-gray-500" data-id="element-17" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="overflow-y-auto px-8 py-6 space-y-6 text-gray-700" data-id="element-18">
                <section data-id="element-19">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-20">
                    1. Aceptación de los Términos
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-21">
                    Al acceder y utilizar este sitio web y al realizar el test
                    de ansiedad, aceptas estar sujeta a los presentes Términos y
                    Condiciones. Si no estás de acuerdo con alguno de estos
                    términos, te pedimos que no utilices nuestros servicios.
                  </p>
                </section>

                <section data-id="element-22">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-23">
                    2. Naturaleza del Contenido
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-24">
                    El test de ansiedad y el material del "Protocolo Mente
                    Serena" son recursos educativos e informativos. No
                    constituyen un diagnóstico médico, psicológico ni
                    psiquiátrico, ni reemplazan la atención de un profesional de
                    la salud mental cualificado.
                  </p>
                </section>

                <section data-id="element-25">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-26">
                    3. Resultados Individuales
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-27">
                    Los resultados del test son orientativos y se basan
                    únicamente en las respuestas proporcionadas por la usuaria.
                    Cada persona es diferente y los resultados pueden variar. No
                    garantizamos ningún resultado específico tras la aplicación
                    del protocolo.
                  </p>
                </section>

                <section data-id="element-28">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-29">
                    4. Propiedad Intelectual
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-30">
                    Todo el contenido del sitio, incluyendo textos, imágenes,
                    diseños, el test, el ebook "Protocolo Mente Serena" y los
                    materiales adicionales, son propiedad exclusiva de la marca
                    y están protegidos por las leyes de derechos de autor. Queda
                    prohibida su reproducción, distribución o modificación sin
                    autorización expresa.
                  </p>
                </section>

                <section data-id="element-31">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-32">
                    5. Compra y Acceso al Producto
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-33">
                    Al adquirir el "Protocolo Mente Serena" recibirás acceso
                    digital inmediato al material. El producto es de uso
                    personal e intransferible. El precio publicado es el precio
                    final aplicable al momento de la transacción.
                  </p>
                </section>

                <section data-id="element-34">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-35">
                    6. Garantía de Devolución
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-36">
                    Ofrecemos una garantía de 7 días desde la fecha de compra.
                    Si dentro de ese plazo consideras que el material no cumple
                    con lo prometido, podrás solicitar la devolución del 100% de
                    tu inversión conforme al procedimiento indicado en tu correo
                    de confirmación.
                  </p>
                </section>

                <section data-id="element-37">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-38">
                    7. Privacidad
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-39">
                    Respetamos tu privacidad. La información proporcionada se
                    trata de manera confidencial y se utiliza únicamente para
                    los fines del servicio. No compartimos tus datos con
                    terceros ajenos al proceso de entrega del producto.
                  </p>
                </section>

                <section data-id="element-40">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-41">
                    8. Limitación de Responsabilidad
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-42">
                    En la máxima medida permitida por la ley, no nos hacemos
                    responsables de daños directos, indirectos, incidentales o
                    consecuenciales derivados del uso o imposibilidad de uso del
                    material. Si presentas síntomas graves de ansiedad u otros
                    trastornos, te recomendamos buscar atención profesional de
                    inmediato.
                  </p>
                </section>

                <section data-id="element-43">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-44">
                    9. Modificaciones
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-45">
                    Nos reservamos el derecho de modificar estos Términos y
                    Condiciones en cualquier momento. Las modificaciones
                    entrarán en vigor desde su publicación en este sitio.
                  </p>
                </section>

                <section data-id="element-46">
                  <h3 className="text-lg font-bold text-dark-blue mb-2" data-id="element-47">
                    10. Legislación Aplicable
                  </h3>
                  <p className="text-sm leading-relaxed" data-id="element-48">
                    Los presentes Términos y Condiciones se rigen e interpretan
                    de acuerdo con las leyes aplicables en los Estados Unidos.
                    Cualquier controversia será resuelta conforme a dicha
                    legislación.
                  </p>
                </section>

                <p className="text-xs text-gray-400 pt-4 border-t border-gray-100" data-id="element-49">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                </p>
              </div>

              {/* Modal Footer */}
              <div className="px-8 py-5 border-t border-gray-100 shrink-0 bg-gray-50" data-id="element-50">
                <button onClick={() => setOpen(false)} className="w-full bg-dark-blue hover:bg-[#162a47] text-white font-bold py-3 rounded-xl transition-colors" data-id="element-51">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};